import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Graficas } from "src/app/graficas/gestionGraficas/graficas.model";
import { sinSelloDeError } from "src/app/shared/http/sello-de-error";
import { MonitoreoFiltro } from "src/app/shared/model/asistencia/asistencia.model";
import { Base } from "src/app/shared/model/core/base.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/**
 * Espejo de AsistenciaDashboardBean (CosCore): lo que la pestaña de
 * asistencia de Inicio NO puede sacar de los endpoints del modulo. Los
 * conteos por estatus del periodo siguen saliendo de monitoreoResumen.do.
 */
export class AsistenciaDashboard extends Base {
  /** yyyy-MM-dd del rango que de verdad se consulto (ya acotado por el servidor). */
  desde: string;
  hasta: string;
  /** Empleados activos con checada de entrada de hoy (sin la captura manual). */
  presentesHoy = 0;
  /** Empleados activos de la empresa. */
  activos = 0;
  /** Empleados activos sin veredicto resuelto hoy. */
  sinRegistrarHoy = 0;
  /** Empleados ACTIVOS sin modalidad vigente hoy: no se evaluan. */
  activosSinModalidad = 0;
  /** Promedio de minutos de retardo sobre los dias con llegada tarde. */
  minutosRetardoPromedio = 0;
  /** Dias del periodo con checada en un sitio distinto al esperado. */
  ubicacionDistinta = 0;
  /** valor1 = origen de la entrada, valor2 = dias. */
  porOrigen: Graficas[] = [];
  /** valor1 = "MM-yy", valor2 = faltas + retardos; ultimos doce meses. */
  porMes: Graficas[] = [];
  /** valor1 = sitio esperado, valor2 = faltas + retardos; los seis con mas. */
  porSitio: Graficas[] = [];
}

/**
 * El endpoint propio de la pestaña de asistencia de Inicio. Lo demas que
 * pinta la pestaña (resumen por estatus, ultimas faltas, telefonos,
 * estaciones) se reusa de AsistenciaService.
 *
 * Como cualquier endpoint que devuelve un bean, el rechazo llega en los
 * headers (SelloDeError): sinSelloDeError lo convierte en error de rxjs
 * para que el forkJoin de la pestaña lo atienda con catchError.
 */
@Injectable({
  providedIn: "root",
})
export class AsistenciaDashboardService {
  constructor(private http: HttpClient) {}

  /** Solo se leen desde y hasta (yyyy-MM-dd); el servidor rechaza rangos de mas de un ano. */
  resumen(filtro: MonitoreoFiltro): Observable<AsistenciaDashboard> {
    return this.http
      .post<AsistenciaDashboard>(UrlConstantes.ASISTENCIA_DASHBOARD, filtro, { observe: "response" })
      .pipe(sinSelloDeError<AsistenciaDashboard>("No se pudo consultar el dashboard de asistencia."));
  }
}
